import { jsx as _jsx } from "react/jsx-runtime";
import { Option } from '@kubit/web-ui-components/option';
import { SelectorRowOption } from './fragments/selectorRowOption/selectorRowOption';
import { SelectorRowVariants } from './types/selectorRow';
export const SelectorRowStandAlone = ({ tabIndex = 0, variant, custom, label, ...props }) => {
    const customVariant = variant === SelectorRowVariants.CUSTOM;
    return customVariant ? (_jsx(SelectorRowOption, { ...props, ...custom, multiSelect: true, rightContent: props.checkedIcon, tabIndex: tabIndex, variant: variant })) : (_jsx(Option, { ...props, multiSelect: true, label: label, tabIndex: tabIndex, variant: `SELECTOR_ROW_${variant}` }));
};
//# sourceMappingURL=selectorRowStandAlone.js.map